import React from "react";
import "./Header.css";
import { useAppData } from "../contexts/AppDataContext";

export default function Header() {
  const { appData, loading } = useAppData();

  const handleDownloadClick = (url, platform) => {
    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
    } else {
      console.log(`${platform} link not available`);
    }
  };

  const androidDisabled = loading || !appData?.androidAppLink;
  const iosDisabled     = loading || !appData?.iosAppLink;

  return (
    <header className="topbar" role="banner">
      <div className="topbar__inner">
        <div className="logo" aria-label="تحرر">تحرر</div>

        <div className="download-buttons" role="group" aria-label="روابط التحميل">
          <button
            type="button"
            className={`btn-android ${!appData?.androidAppLink && !loading ? "disabled" : ""}`}
            onClick={() => handleDownloadClick(appData?.androidAppLink, "Android")}
            disabled={androidDisabled}
          >
            {loading ? "جارٍ التحميل..." : "تحميل Android"}
          </button>

          <button
            type="button"
            className={`btn-ios ${!appData?.iosAppLink && !loading ? "disabled" : ""}`}
            onClick={() => handleDownloadClick(appData?.iosAppLink, "iOS")}
            disabled={iosDisabled}
          >
            {loading ? "جارٍ التحميل..." : "تحميل iOS"}
          </button>
        </div>
      </div>
    </header>
  );
}
